// The minimum length Xano will accept for a patient search.
//
// GET /patient (api 162, api:Bh0CIPqU) opens its `type: "search"` branch with
//   precondition (($input.search|strlen) >= 3) { error = "Search term must be more than 3 Characters" }
// so a 1–2 character term does NOT come back as an empty list — it comes back as
// a 500 that the proxy surfaces verbatim, which is what the user sees. (The
// message wording is off by one: the guard is `>= 3`, so 3 characters is fine.)
//
// Thai counts the same in JS as it does in Xano's strlen: every Thai code point
// — consonant, vowel sign, tone mark — is one BMP code unit, so "นี" is 2 on both
// sides. That means gating on `.length` here is exactly the backend's rule, and
// a 2-letter Thai search is correctly refused rather than fired and failed.
export const MIN_PATIENT_SEARCH = 3

// True when `term` is long enough for Xano to accept it. Every patient picker
// gates its fetch on this so no search request can produce that 500 again.
export function canSearchPatients(term) {
  return String(term ?? '').trim().length >= MIN_PATIENT_SEARCH
}
